import {Dialog} from '@mui/material'
import {styled} from '@mui/system'

export const FileViewerModalStyled = styled(Dialog)(({theme}) => ({
  '.modal-container': {
    height: 'calc(100vh - 190px)',
    width: 'calc(100vw - 150px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },

  // La X sta nella fascia bianca sopra il contenuto (padding-top del Paper), così
  // non si sovrappone alla toolbar scura del viewer PDF né all'immagine.
  '.close-button': {
    position: 'absolute',
    top: '8px',
    right: '8px',
    zIndex: 1,
    color: '#2c3e50'
  },

  '.MuiPaper-root': {
    position: 'relative',
    maxWidth: '100%',
    borderRadius: '15px',
    padding: '56px 15px 15px'
  }
}))
